import { differenceInDays, formatDistance, formatRelative, parseISO } from "date-fns";

import { customLocaleWithoutTime } from "./customLocale.ts";
import { formatDateTimeFromISO } from "./toDateTime.ts";

export const toTimeAgo = (dateTimeISO: string, hideTime?: boolean | null): string => {
  try {
    const now = new Date();
    const date = parseISO(dateTimeISO);
    const diffInDays = Math.abs(differenceInDays(now, date));

    if (diffInDays < 3) {
      // in the very recent past or future, we show the time (locally formatted)
      return `${formatRelative(date, now, { locale: customLocaleWithoutTime })}${
        hideTime ? "" : " at " + formatDateTimeFromISO(dateTimeISO, { timeOnly: true })
      }`;
    } else if (diffInDays < 6) {
      return formatRelative(date, now, { locale: customLocaleWithoutTime });
    } else if (diffInDays < 30) {
      return `${formatDateTimeFromISO(dateTimeISO, { hideTime: true })}`; // always hide the time information in case of "time ago" relative dates
    } else {
      return formatDistance(date, now, {
        addSuffix: true, // e.g. "about"
        locale: customLocaleWithoutTime,
      });
    }
  } catch {
    console.error("The date " + dateTimeISO + " could not be formatted");
    return "";
  }
};
